import { ISortOption } from '~types/search'

export const SORT_BASE_OPTIONS = ['', 'PRICE']

export const SORT_EQUIVALENT: ISortOption[] = [
  {
    value: 1,
    key: 'default',
    searchBy: '',
  },
  {
    value: 2,
    key: 'asc',
    searchBy: 'PRICE',
  },
  {
    value: 3,
    key: 'desc',
    searchBy: 'PRICE',
  },
  {
    value: 4,
    key: 'asc',
    searchBy: 'NAME',
  },
  {
    value: 5,
    key: 'desc',
    searchBy: 'NAME',
  },
  {
    value: 6,
    key: 'asc',
    searchBy: 'PRICE_PER_SUB_UNIT',
  },
  {
    value: 7,
    key: 'desc',
    searchBy: 'PRICE_PER_SUB_UNIT',
  },
  {
    value: 8,
    key: 'asc',
    searchBy: 'EXTERNAL_CREATION_DATE',
  },
  {
    value: 9,
    key: 'desc',
    searchBy: 'EXTERNAL_CREATION_DATE',
  },
  {
    value: 10,
    key: 'desc',
    searchBy: 'PROMOTION_ACTIVE',
  },
]
